<template>
  <div class="dc">
    <!--企业用户君子盾-->
    <template v-if="$store.getters.authUser.userType == 1">
      <!--第一步显示商品-->
      <div v-if="step == 'info'" class="row step">
        <template v-if="!$utils.isEmptyObj(certApply) && certApply.applyStatus!=2">
          <template v-if="certApply.applyStatus==0">
            <div class="" v-if="certApply.ifApi==0">
              <img src="/images/u10.jpg" alt="" />
              您的API商户已为您申请君子盾，但须验证对公账户。
              <button type="button" class="btn btn-primary  margin-large-t" id="addCert" @click="step = 'validate'">
                立即验证对公账户
              </button>
            </div>
            <template v-if="certApply.ifApi==1">
              <div class="box">
                <h4 class="color-success">对公账户付款</h4>
                <p><span class="color-danger">请务必使用贵公司对公账户完成付款。</span> 请在10个工作日内使用对公账户向君子签完成指定金额的汇款，以便完成君子盾的购买。</p>
                <table>
                  <tbody>
                  <tr>
                    <td><b>开户名</b></td>
                    <td>重庆君子签科技有限公司</td>
                  </tr>
                  <tr>
                    <td><b>对公账户</b></td>
                    <td>3108 1401 0400 0058 2</td>
                  </tr>
                  <tr>
                    <td><b>开户行</b></td>
                    <td>农业银行</td>
                  </tr>
                  <tr>
                    <td><b>开户地点</b></td>
                    <td>重庆两江星光支行</td>
                  </tr>
                  <tr>
                    <td><b>指定金额</b></td>
                    <td>300元</td>
                  </tr>
                  <tr>
                    <td><b>汇款备注</b></td>
                    <td>购买CA</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </template>
          </template>
          <template v-if="certApply.applyStatus==1">
            <div class="col-xs-4 text-right">
              <img src="/images/u10.jpg" alt="" />
            </div>
            <div class=" col-xs-5">
              恭喜，您已获得君子盾。
              <br/>类型：
              <template v-if="certApply.userType == 0">软证书</template>
              <template v-if="certApply.userType == 1">硬key</template>
              <br/>序列号：{{certApply.icnumber}}
              <br/>申请时间：{{certApply.createTime|formatDate }}
              <br/>发放时间：{{certApply.updateTime|formatDate }}
              <br/>有效期：{{certApply.validity}}天
              <br/>有效期至：{{certApply.expireTime|formatDate}}
            </div>
          </template>
        </template>
        <template v-else>
          <div class="product-page">
            <img src="/images/u10.jpg" alt="" />
            <p>
              君子盾是您签署的身份凭证之一，同时您将拥有独一无二无可仿冒的<b>数字签名</b>。<br /> <br />
              申请君子盾后，只能在安装了<b>软证书</b>或者插有<b>硬key</b>的电脑才能完成电子签署。<br />
              当您更换电脑或重装系统时，需要重新安装君子盾控件。
              <a href="@/asset/君子盾控件.exe">点此安装君子盾控件</a>（强烈建议关闭杀毒软件）请联系您的API商户为您申请。
            </p>
            <a @click="step = 'pay'" href="javascript:void (0)" class="bg-success btn">不联系，自主申请</a>
          </div>
        </template>
      </div>

      <template v-if="step == 'pay'" >
        <el-form size="small" label-width="390px" class="pay-form">
          <el-form-item label-width="300px">
            <h4 class="color-success">付款和邮寄地址</h4>
          </el-form-item>

          <el-form-item label-width="300px">
            <p>付款购买君子盾，<span class="color-danger">君子盾硬key的邮寄地址以申请表填写的为准。</span></p>
          </el-form-item>

          <el-form-item label="应付金额：">
            <p>300.00元</p>
          </el-form-item>

          <el-form-item label="付款方式：">
            <p>对公账户汇款</p>
          </el-form-item>

          <el-form-item label="申请表扫描件：">
            <el-row>
              <el-col :span="8"><el-input disabled placeholder="请选择申请书扫描件" :value="file ? file.name : ''" /></el-col>
              <el-col :span="10" :offset="1">
                <div class="upload-copy" style="position: relative">
                  <el-button type="danger" class="btn">选择文件</el-button>
                  <input @change="chooseFile($event)" type="file" style="display: block; position: absolute; width: 100%; height: 100%; top: 0px; left: 0px; z-index: 999 " />
                </div>
                <a href="/君子盾申请表.doc" style="vertical-align: top;">申请表模板下载</a>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label-width="300px">
            <el-row>
              <el-col :span="9">
                <el-button @click="payFrmSubmit()" type="success" class="btn__submit">提交并付款</el-button>
              </el-col>
              <el-col :span="4" :offset="1">
                <el-button @click="step = 'info'" class="btn-cancle">取消</el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </template>

      <template v-if="step == 'validate'" >
        <div v-if="true" class="box">
          <h4><b class="color-success">对公账户验证</b></h4>
          <p>
            通过银行系统完成身份验证，确保企业身份的真实性；请在10个工作日内使用对公账户向君子签完成指定金额的汇款，以便完成验证。
          </p>
          <table class="table table-bordered">
            <tr>
              <td><b>开户名</b></td>
              <td>重庆君子签科技有限公司</td>
            </tr>
            <tr>
              <td><b>对公账户</b></td>
              <td>3108 1401 0400 0058 2</td>
            </tr>
            <tr>
              <td><b>开户行</b></td>
              <td>农业银行</td>
            </tr>
            <tr>
              <td><b>开户地点</b></td>
              <td>重庆两江星光支行</td>
            </tr>
            <tr>
              <td><b>指定金额</b></td>
              <td>
                <span id="randomYuan" v-if="!$utils.isEmptyObj(certApply) && certApply.applyStatus==0">{{certApply.randomMoney}}</span>元
                <span class="color-danger">（非指定金额将会验证失败）</span>
              </td>
            </tr>
            <tr>
              <td><b>汇款备注</b></td>
              <td>对公验证</td>
            </tr>
          </table>
        </div>
      </template>

    </template>
    <!--个人用户签盾-->
    <template v-else>
      <div style="height: 300px; line-height: 300px;">
        个人用户君子盾功能还在开发中！
      </div>
    </template>
  </div>
</template>

<script>
  import {ApiMethods} from '@/assets/js/http-serve/http-methods';

  export default {
    data() {
      return {
        certApply:{},
        step: "info",
        file:null,
      }
    },
    methods: {
      loadInfo:function(){
        var _this = this;
        ApiMethods.SecurityController.certApplyInfo({}).then(result => {
          //{certificateApplyId,applyStatus,ifApi,validity,userType,createTime,updateTime,icnumber,randomMoney}
          if(!result.success){
             _this.$message.error(result.description || this.$tip);
            window.location.reload()
          }
          _this.certApply = result.data||{};
        });
      },
      payFrmSubmit:function(){
        var _this = this;
        if(!_this.file) {
          return _this.$message.error("请选择上传申请表！");
        }
        var frm = new FormData();
        frm.append("applyTable", _this.file);
        ApiMethods.SecurityController.certApplyEnt(frm).then(result => {
          if(result.success){
            _this.$message.success(result.description || this.$tip)
            setTimeout(()=>{
              window.location.reload();
            },1000)
          } else {
            _this.$message.error(result.description || this.$tip);
          }
        });
      },
      // 上传扫描件
      chooseFile (e) {
        var file = e.target.files[0]
        if (file) {
          if (file.size > 10 * 1024 * 1024) {
            e.value = ''
            return this.$message.error('上传文件不能超过30M')
          }
          this.file = file
        }
        e.value = ''
      },
    },
    created() {
      this.loadInfo();
    },
    name: "dc"
  }
</script>

<style lang="less" scoped>
.dc {
  padding: 40px 20px;

  .pay-form {
    .upload-copy {
      display: inline-block;
      position: relative;
      width: 80px;
      height: 32px;
      margin-right: 5px;
      overflow: hidden;

      input {
        position: absolute;
        top: -27px;
        left: -45px;
        width: 200px;
        height: 300px;
        cursor: pointer;
        opacity: 0;
      }
    }
    .btn__submit {
      width: 100%;
    }
    p {
      margin-bottom: 0;
    }
  }

  .product-page {
    .btn {
      display: inline-block;
      color: #ffffff;
      background-color: #009899;
      border-color: #009899;
      margin-top: 20px;
      padding: 6px 12px;
      font-size: 14px;
      line-height: 1.42857143;
      border-radius: 2px;
    }

    img {
      height: 145px;
      vertical-align: top;
    }
  }

  table {
    border: 1px solid #dddddd;
    width: 100%;
    td {
      border: 1px solid #dddddd;
      line-height: 3;
      text-align: left;
      padding: 8px 10px;
      font-size: 16px;
    }
  }

  h4 {
    font-size: 18px;
  }

  p {
    margin-bottom: 10px;
  }

  .box {
    width: 50%;
    margin: 0 auto;
  }
}
.el-form-item{
  height: 40px;
  position: relative;
  /deep/.el-form-item__content{
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// pages/signSettings/security/dc.vue